import { motion } from "framer-motion";

import { ClientAvatar } from "./ClientAvatar";
import type { ClientAvatarProps } from "./types";

export const AnimatedClientAvatar: React.FC<
  ClientAvatarProps & { layoutId: string }
> = ({ layoutId, ...props }) => {
  return (
    <motion.div
      animate={{
        opacity: 1,
        scale: 1,
      }}
      initial={{
        opacity: 0,
        scale: 0.2,
      }}
      layoutId={layoutId}
      style={{
        position: "relative",
      }}
      transition={{
        duration: 0.4,
      }}
      layout
    >
      <ClientAvatar {...props} />
    </motion.div>
  );
};
